import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"

import { AccessManagementAddUserToTeamForm } from "./add-user-to-team-form"
import { AccessManagementFilterForm } from "./filter-form"
import { AccessManagementTable } from "./table"
export const AccessManagementTabs = () => {
  const tabs = {
    teamAccess: "team-access",
    createAccess: "create-access",
  }
  return (
    <Tabs defaultValue={tabs.teamAccess}>
      <TabsList>
        <TabsTrigger value={tabs.teamAccess}>Acessos equipes</TabsTrigger>
        <TabsTrigger value={tabs.createAccess}>Criar acesso</TabsTrigger>
      </TabsList>
      <TabsContent value={tabs.teamAccess} className="space-y-4">
        <AccessManagementFilterForm />
        <div>
          <h2 className="text-center text-xl font-semibold">
            Gerenciamento de equipe
          </h2>
        </div>
        <AccessManagementTable />
      </TabsContent>
      <TabsContent value={tabs.createAccess} className="space-y-4">
        <AccessManagementAddUserToTeamForm />
      </TabsContent>
    </Tabs>
  )
}
